import { appstr } from "@coreapp/utils/appstr";
import { enumFieldType } from "@coreapp/constants";
import type { QObjDBFieldDef } from "@coreapp/CoreApp/QObjDBFieldDef";

export const getComparisonLabel = (
  comparison: string,
  toField: boolean,
  fieldDef: QObjDBFieldDef
) => {
  const isDateField = fieldDef?.GetFieldType() === enumFieldType.date;
  let suffix = "";
  if (toField) {
    suffix = ` <${appstr("Field")}>`;
  }

  if (!isDateField) {
    return `${appstr(comparison)}${suffix}`;
  }

  let label = "";
  switch (comparison) {
    case "greater":
      label = appstr("after");
      break;
    case "less":
      label = appstr("before");
      break;
    case "greaterequal":
      label = appstr("afterequal");
      break;
    case "lessequal":
      label = appstr("beforeequal");
      break;
    default:
      label = appstr(comparison);
  }

  return `${label}${suffix}`;
};
